export default (function (target, className) {
  if (target.classList) {
    return !!className && target.classList.contains(className);
  }

  return (" " + target.className + " ").indexOf(" " + className + " ") !== -1;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/classNames/hasClass.js
// module id = 546
// module chunks = 33